import Base from './condition-base'
import renderFields from './timer.pug'

export default class Timer extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  @DEFAULTS:
    seconds: 0

  renderFields: renderFields
